angular.module('backstage.directives.tools', [])
    .directive('btDndDraggable', require('./btDndDraggable'))
    .directive('btDndDraggableHandler', require('./btDndDraggableHandler'))
    .directive('btDndDroppable', require('./btDndDroppable'))
    .directive('btHighchart', require('./btHighchart'))
    .directive('btModal', require('./btModal'))
    .directive('btPermalinkLauncher', require('./btPermalinkLauncher'))
    .directive('btSystemjsDirectiveLoader', require('./btSystemjsDirectiveLoader'))
    .directive('btQrCode', require('./btQrCode'));
